import React, { useMemo, useState } from 'react'
import classnames from 'classnames'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import formatDuration from 'lib/format-duration'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
SwiperCore.use([Navigation])

const play_icon = require('static/play-video.png')
interface IProps {
  seriesId: number
  seriesName: string
  type: number
  videoManualData: IVideo
  id?: string
}

export interface IVideo {
  category_list: ICategoryTitle[]
  data_list: ICategoryData[]
}

interface ICategoryTitle {
  text: string
  type: number
}

interface ICategoryData {
  unique_id_str: string
  info: {
    title?: string
    card_content: {
      video_list: IVideoList[]
    }
  }
}

interface IVideoList {
  title: string
  cover_url: {
    url: string
  }
  gid_str: string
  vid: string
  duration: number
}

interface IVideoType {
  categoryList: ICategoryTitle[]
  currIndex: number
  setCurrIndex: (currIndex: number) => void
}

interface IVideoProps {
  dataList: IVideoList[]
  seriesId: number
  seriesName: string
  currIndex: number
  type: number
  setCurrIndex: (currIndex: number) => void
}

interface ISwiper {
  slideToLoop: (index: number) => {}
}

let flag = false
function VideoType({ categoryList, currIndex, setCurrIndex }: IVideoType) {
  if (!categoryList?.length) return null
  return (
    <div className="container">
      {categoryList.map((data, index) => {
        return (
          <div
            key={data.text}
            className={classnames({ active: currIndex === index }, 'item')}
            onClick={e => {
              e.stopPropagation()
              flag = true
              setCurrIndex(index)
            }}
          >
            {data.text}
          </div>
        )
      })}
      <style jsx>
        {`
          .container {
            padding: 12px 0 16px 0;
            display: flex;
            flex-wrap: wrap;
          }
          .item {
            border-radius: 2px;
            padding: 3px 12px;
            margin-right: 8px;
            margin-bottom: 8px;
            cursor: pointer;
            background-color: #f7f8fc;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #1f2129;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
          }
          .active {
            background-color: rgba(255, 204, 50, 0.12);
          }
        `}
      </style>
    </div>
  )
}

function VideoContent({ dataList, seriesId, seriesName, type }: IVideoProps) {
  if (!dataList?.length) return null

  const params = {
    navigation: {
      nextEl: '.video-manual-next',
      prevEl: '.video-manual-pre',
    },
    spaceBetween: 8,
    slidesPerView: type === 1 ? 4 : 5,
    slidesPerGroup: type === 1 ? 4 : 5,
    preventClicks: false,
    simulateTouch: false,
    watchOverflow: true,
    loop: true,
  }
  const videoWidth = type === 1 ? '203px' : '142px'
  const videoHeight = type === 1 ? '334px' : '238px'
  const titleHeight = type === 1 ? '30px' : '32px'
  const titleFontSize = type === 1 ? '12px' : '12px'
  const playButtonBottom = type === 1 ? '40px' : '40px'
  const Ele = ({ video, index }: { video: IVideoList; index: number }) => (
    <div className="slide">
      <Link
        href={`/auto/video?seriesId=${seriesId}&gid=${video.gid_str}`}
        as={`/auto/series/${seriesId}/videoManual/${video.gid_str}`}
      >
        <a
          className="video-content"
          target="_blank"
          onClick={() => {
            sendTeaCommEvent('click_series_instruction_video_single', {
              car_series_name: seriesName,
              car_series_id: seriesId,
              series_module_name: '视频说明书',
              rank: index,
            })
          }}
        >
          <img key={video.vid} src={video.cover_url.url} className="zoom" />
          <div className="video-title">
            <p className="line-1">{video.title}</p>
          </div>
          <div className="duration">
            <img src={play_icon} />
            {formatDuration(video.duration)}
          </div>
        </a>
      </Link>
      <style jsx>
        {`
          .slide {
            width: ${videoWidth} !important;
            height: ${videoHeight} !important;
            position: relative;
            display: inline-block;
            margin-right: 8px;
            border-radius: 2px;
            overflow: hidden;
          }
          .slide:nth-child(4n + 4) {
            margin-right: 0;
          }
          .video-content {
            width: 100%;
            height: 100%;
            display: inline-flex;
            position: relative;
          }
          .video-content img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          .video-content > img:last-child {
            margin-right: 0;
          }

          .video-title {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: ${titleHeight};
            background-image: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.2) 0%,
              rgba(0, 0, 0, 0.8) 100%
            );
            border-radius: 0 0 1px 1px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .video-title > p {
            font-family: PingFangSC-Regular;
            font-size: ${titleFontSize};
            color: rgba(255, 255, 255, 0.9);
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 400;
          }
          .slide:hover .video-title > p {
            color: #ffcc32;
          }
          .duration {
            position: absolute;
            bottom: ${playButtonBottom};
            right: 8px;
            height: 18px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 2px;
            min-width: 47px;
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            transform: scale(0.833);
            transform-origin: left center;
            color: white;
            letter-spacing: 0;
            line-height: 14px;
            font-weight: 400;
            padding: 2px 6px;
          }
          .duration > img {
            object-fit: cover;
            object-position: center;
            width: 12px;
            height: 12px;
            margin-right: 2px;
          }
        `}
      </style>
    </div>
  )

  const elements = useMemo(() => {
    return dataList.map((video, index) => (
      <SwiperSlide key={video.gid_str + index}>
        <Ele video={video} index={index} />
      </SwiperSlide>
    ))
  }, [dataList])

  return (
    <div className="video-content-wrapper">
      {dataList.length > 1 ? (
        <Swiper {...params}>
          {elements}
          <span className="swiper-nav-pre video-manual-pre" />
          <span className="swiper-nav-next video-manual-next" />
        </Swiper>
      ) : (
        <Ele video={dataList[0]} index={0} />
      )}

      <style jsx>
        {`
          :global(.video-content-wrapper
              .swiper-button-prev, .video-content-wrapper .swiper-button-next) {
            height: 48px;
            width: 32px;
            opacity: 1;
            background: rgba(0, 0, 0, 0.4);
            margin-top: -24px;
          }
          :global(.video-content-wrapper
              .swiper-button-prev:after, .video-content-wrapper
              .swiper-button-next:after) {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 12px;
            left: 4px;
            background-image: url(${require('static/left-ic.png')});
            background-size: cover;
            margin: 0;
          }
          :global(.video-content-wrapper
              .swiper-button-prev:hover, .video-content-wrapper
              .swiper-button-next:hover) {
            background: #f5b330;
            opacity: 1;
          }
          :global(.video-content-wrapper .swiper-button-prev:after) {
            transform: rotateZ(-180deg);
          }
          :global(.video-content-wrapper .swiper-button-disabled) {
            display: none;
          }
        `}
      </style>
    </div>
  )
}

export default function VideoManual({
  seriesId,
  seriesName,
  type,
  videoManualData,
  id,
}: IProps) {
  const [dataList] = useState<ICategoryData[]>(videoManualData.data_list)
  const [currIndex, setCurrIndex] = useState(0)
  const allVideoList = useMemo(() => {
    const allVideoList: IVideoList[][] = []
    for (let i = 0; i < dataList?.length; i++) {
      if (!dataList?.[i]?.info?.title) {
        allVideoList.push(dataList[i].info?.card_content?.video_list || [])
      }
    }
    return allVideoList
  }, [dataList])
  const videoList = useMemo(() => {
    return allVideoList?.[currIndex] || []
  }, [allVideoList, currIndex])
  return (
    <section className="video-manual">
      <p className="title" id={id || ''}>
        视频说明书
      </p>
      <div>
        <VideoType
          categoryList={videoManualData.category_list}
          currIndex={currIndex}
          setCurrIndex={(currIndex: number) => {
            setCurrIndex(currIndex)
          }}
        />
        <VideoContent
          dataList={videoList}
          seriesId={seriesId}
          seriesName={seriesName}
          currIndex={currIndex}
          setCurrIndex={(currIndex: number) => {
            setCurrIndex(currIndex)
          }}
          type={type}
        />
      </div>
      <style jsx>
        {`
          .video-manual {
            background: #ffffff;
            border-radius: 2px;
            width: ${type === 1 ? '868px' : '742px'};
            margin-top: 8px;
            padding: ${type === 1 ? '16px' : '16px 0 0 0'};
          }
          .title {
            font-size: 18px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 500;
          }
        `}
      </style>
    </section>
  )
}
